<template>
  <multi-selector v-model="status" :filterable="false" :options="caseStatusList" :remote="caseStatusSearch"></multi-selector>
</template>
<script>
import MultiSelector from '../Select';

export default {
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    caseStatus: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      status: [],
      caseStatusList: []
    };
  },
  mounted() {
    this.caseStatusSearch('');
  },
  watch: {
    status() {
      this.$emit('input', this.status.map(item => item.modelCode));
    }
  },
  methods: {
    // 案件状态下拉框
    caseStatusSearch(val) {
      this.$ajax({
        method: 'GET',
        url: '/dict/getList/caseStatus',
        params: { 'val': val }
      }).then((res) => {
        res.data.map((item) => { item.title = item.modelName; return item; });
        this.caseStatusList = res.data;
        this.caseStatusList.forEach((item) => {
          if (this.caseStatus.indexOf(item.modelCode) !== -1) {
            this.status.push(item);
          }
        });
      });
    }
  },
  components: {
    MultiSelector
  }
};
</script>



// WEBPACK FOOTER //
// src/components/bussiness-select/CaseStatusSelector.vue